import React, { useEffect, useState } from 'react';
import v from '../../styles/img/arrow/v.svg';
import Ratingstar from '../../components/Rating_star';
import { useDispatch } from 'react-redux';
import { claimUserGift, findUser } from '../../actions/userActions';
import useAxios
 from '../../axios/useAxios';
import { USER_CLAIM_GIFT_RESET } from '../../constants/userConstants';
import PopupSample from '../../components/Popup_sample';
import Confetti from 'react-confetti';
import tiret_coupons from '../../styles/img/tiret_coupons.svg';
import { displayCouponNameProperly } from '../../utils/StringUtils';
import { useNavigate } from 'react-router';

const CurrentPromo = ({ user }) => {
  const navigate = useNavigate();
  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  const [isContentVisible, setIsContentVisible] = useState(false);
  const currentPromoLength = user?.currentPromo?.length;

  useEffect(async () => {
    dispatch({ type: USER_CLAIM_GIFT_RESET });
    await dispatch(findUser(user, axiosInstance, navigate));
  }, []);

  const applyPromo = (promoItem) => {
    dispatch(claimUserGift(user._id, axiosInstance, promoItem));
  };
  const [popUpActivate, setPopUpActivate] = useState(false);
  const [popUpSCale, setPopUpSCale] = useState(false);
  useEffect(() => {
    if (user.userClaimGift && user.userClaimGift === true) {
      setPopUpActivate(true);
      setPopUpSCale(true);
    }
  }, [user.userClaimGift]);
  return (
    <>
      {user.userClaimGift && user.userClaimGift === true ? (
        <>
          <div
            className={`${popUpActivate ? 'opacity-[1]' : 'opacity-0'} transition-all w-full h-full flex items-center justify-center z-[100]  absolute h-[100dvh] w-[100dvw] bg-[#000000ad] transform translate-x-[-50%] translate-y-[-50%] left-[50%] top-[50%] `}
            onClick={() => dispatch({ type: USER_CLAIM_GIFT_RESET })}
          >
            <Confetti
              className="block confettis"
              width={window.innerWidth}
              height={window.innerHeight}
              recycle={false}
              numberOfPieces={400}
              gravity={0.1}
              color="['#e1ff26' '#ffa703']"
            />
            <div
              className={`${popUpSCale ? 'scale-[1]' : 'scale[0]'} transition-all w-[90%] p-10 px-8 text-[16px] rounded-[1em] text-center flex flex-col bg-white items-center`}
            >
              <span className="text-2xl">
                Bravo tu viens de débloquer ton cadeau !! 🤩🤩
              </span>
              <span className="text-base">
                Un mail vient d'être envoyé à {user.email}
              </span>

              <button className="flex payer mt-6 w-full p-4 geomanistBold text-[1.6rem] w-11/12 justify-center items-center">
                Génial !
              </button>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
      <div
        className="w-full relative border-solid border-gray-300 rounded-[1em] border-[1px]"
        id="LocationFinalOfgift"
      >
        <span
          className="px-2 py-2 absolute top-[-10px] payer shadow-md !rounded-full text-[12px]"
          style={{ zIndex: 1 }}
        >
          {currentPromoLength}
        </span>
        <div
          className={` bg-white flex flex-col justify-start items-start  w-full py-2 max-h-[90px] transition-all duration-300 px-4 pt-2 rounded-[13px] relative  overflow-hidden${isContentVisible ? ' max-h-[fit-content]' : ' max-h-[90px]'}`}
        >
          <div
            onClick={() => setIsContentVisible(!isContentVisible)}
            className="flex w-full justify-between items-start px-4 relative items-center py-8"
          >
            <div
              className="text-[14px] w-[85%] "
              style={{ fontFamily: 'Open Sans' }}
            >
              Mes cadeaux obtenus
            </div>
            <img
              src={v}
              alt="arrow"
              className={`transition-all ${isContentVisible ? ' rotate-180' : ''}`}
            />
          </div>
          {isContentVisible ? (
            <div
              id=""
              style={{ fontFamily: 'Open Sans' }}
              className={`transition-all duration-700 text-[16px] flex items-center rounded-[10px] bg-white px-4  w-full flex-wrap opacity-0 h-auto overflow-hidden ${
                isContentVisible ? ' opacity-[1] ' : ''
              }`}
            >
              <div
                className="flex flex-col justify-center items-center w-full   pt-10 rounded-[3em] mb-10 gap-6"
                style={{ backgroundColor: '#FFF' }}
              >
                {user.currentPromo
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((promoItem, index) => {
                    const delay = index * 0.1;
                    return (
                      <>
                        <ul
                          className={
                            index > 0
                              ? '![animation-delay:_' +
                                delay +
                                's] w-full appear transform translate-x-[120%] '
                              : ' w-full apparition'
                          }
                        >
                          <li>
                            <div className="coupons2">
                              {/*<div className="offert text-2xl mt-2 flex flex-col items-start justify-center gap-2">*/}
                              {/*<h1 className="geomanistBold">{promoItem.name.slice(5).length>4?<div className='geomanistBold text-[1.5rem]'>{promoItem.name.slice(5)}</div>:promoItem.name.slice(5).replace("e","€")}</h1>*/}
                              {/*{promoItem.category==='pourcentage' || promoItem.category==="substract"?<span className='geomanistBold'>Offert</span>:null}*/}
                              {/*</div>*/}
                              <div className="offert text-2xl  flex flex-col  items-center ml-3  justify-center">
                                <h1 className="promo-value">
                                  {displayCouponNameProperly(promoItem)}
                                </h1>
                                <span className="text-[12px]">Offert</span>
                              </div>
                              <img
                                src={tiret_coupons}
                                className="h-[60px] mx-4"
                                alt=""
                              />
                              <div className="offert2 flex flex-col gap-2">
                                <span
                                  className="text-[14px] opacity-[0.9]"
                                  style={{ fontFamily: 'Open Sans' }}
                                >
                                  {promoItem.description}
                                </span>

                                {promoItem.category === 'claim' ? (
                                  <button
                                    onClick={() => applyPromo(promoItem)}
                                    className={
                                      'apparition text-xl promoscreen_button p-4'
                                    }
                                    style={{ fontFamily: 'geomanistmedium' }}
                                  >
                                    Activer
                                  </button>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </li>
                        </ul>
                      </>
                    );
                  })}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};
export default CurrentPromo;
